<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col :span="8" :push="8">
          <el-card>
            <template slot="header">
              欢迎管理员登录
            </template>
            <el-form label-position="right" label-width="80px">
              <el-form-item label="用户名：">
                <el-input v-model="loginForm.userName"></el-input>
              </el-form-item>
              <el-form-item label="密码：">
                <el-input type="password" v-model="loginForm.passwd"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" style="float: right;" @click="login">登录</el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
  import axios from 'axios'
  import config from '@/lib/http/config'
  import http from '@/lib/admin/http'

  export default {
    name: "Login",
    created() {
      this.$store.dispatch('initAdmin')
        .then(_ => {
          console.log(2333);
          console.log(this.$store.getters.isLogin);

          // if(this.$store.getters.isLogin){
          //   this.$router.go(-1);
          // }
        });

    },
    data() {
      return {
        loginForm: {
          userName: "admin2",
          passwd: ""
        },

      }
    },
    methods: {
      login() {
        let userName = this.loginForm.userName;
        let passwd = this.loginForm.passwd;

        let vthis = this;
        axios.post(config.rootUrl + '/oauth/token', {
          grant_type: 'password',
          client_id: 5,
          client_secret: 'MbC2Srk3OGGeH8SPlluZehvlifCBTCDygEfZMeKC',
          username: userName,
          password: passwd,
          scope: ''
        }).then(async res => {
          if (res.data.access_token) {
            this.$store.commit('setToken', res.data);
            let resData = await vthis.getAdminInfo();
            this.$store.commit('setAdminInfo', resData.data.data);

            this.$router.push({
              path: "/"
            });
          }
        }).catch(error => {
          this.$message.error('用户名或密码错误');
          vthis.loginForm.password = '';
        });
      },
      getAdminInfo() {
        return http.getData('/api/admin/now_admin')
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/login/Login.vue